import React from 'react';
import { useTranslation } from 'react-i18next';

import { InputHandler } from '../../../../../viewer/input-handler';
import { ReportTool } from '../../../../../viewer/tools/report-tool';
import { SkyviewContext } from '../../../skyview/skyview-state';
import { ToolIcon } from '../tool-icon';

const ReportToolIcon = () => {
  const { t } = useTranslation();
  const { activeTool } = React.useContext(SkyviewContext);

  return (
    <>
      <ToolIcon
        active={activeTool instanceof ReportTool}
        callback={() => {
          InputHandler.instance.setTool('report');
        }}
        disabled={false}
        icon={['fal', 'file-alt']}
        tooltip={{
          title: t('report.tooltip.title', { ns: 'skyviewToolbar' }),
          text: t('report.tooltip.text', { ns: 'skyviewToolbar' }),
        }}
      />
    </>
  );
};

export { ReportToolIcon };
